import React from 'react';
import styles from './ReportCardChartLegend.module.scss';

export const ReportCardChartLegend = ({ payload, isPeriod }) => {
  const getLegendPayload = (payload) => {
    const uniqueKeys = new Set();

    return payload.reduce((acc, item) => {
      const baseKey = item.dataKey.replace(/(Plan|Fact|Closed)$/, '');

      if (!uniqueKeys.has(baseKey)) {
        uniqueKeys.add(baseKey);
        acc.push({
          dataKey: baseKey,
          value: item.value.replace(
            /\s*\(План\)|\s*\(Факт\)|s*\(Закрытые\)/g,
            ''
          ),
          color: item.color,
        });
      }

      return acc;
    }, []);
  };

  const filteredPayload = !isPeriod ? payload : getLegendPayload(payload);

  return (
    <div className={styles.root}>
      <ul className={styles.list}>
        {filteredPayload.map((entry, index) => (
          <li
            key={`item-${index}`}
            className={styles.listItem}
          >
            <span style={{ color: entry.color }}>{entry.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
